var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 0H2C0.893333 0 0 0.791943 0 1.77301V11.229C0 12.2101 0.893333 13.002 2 13.002H7.33333C8.44 13.002 9.33333 12.2101 9.33333 11.229V1.77301C9.33333 0.791943 8.44 0 7.33333 0ZM6 11.82H3.33333V11.229H6V11.82ZM8.16667 10.047H1.16667V1.77301H8.16667V10.047Z",
    fill: "#B6B8D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSms);
export default __webpack_public_path__ + "static/media/icn-sms.ad3ea5cb0041ce4fd24207dce9d03596.svg";
export { ForwardRef as ReactComponent };